/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax 
  Author: Martin Vicencio -benko hank
  Author URL: martinvicencio.com
==========================================================================================*/
export default [
  {
    url: null,
    name: "Mi Perfil",
    slug: "Mi Perfil",
    icon: "UserIcon",
    i18n: "Mi Perfil",
    submenu: [
      {
        url: '/vinculacion/datos_user',
        name: "AlumnosCe",
        slug: "AlumnosCe",
        i18n: "Perfil",
      },
     ]
  },
  {
    url: null,
    name: "Servicios escolares",
    slug: "alumnos",
    icon: "CheckSquareIcon",
    i18n: "Servicios escolares",
    submenu: [
      {
        url: '/alumnos/calendarioescolar',
        name: "Calendario Escolar",
        slug: "calendarioEscolar",
        i18n: "Calendario Escolar",
      },
      {
        url: '/vinculacion/inf_alumnos',
        name: "Alumnos",
        slug: "alumnos",
        i18n: "Alumnos",
      }
    ]
  }


]
